import React, { useState, useEffect, useRef } from 'react';
import { formatDate, renderInputField, getPlaceholder, urlBase64ToUint8Array } from './utils';
import './HomeBaseForm.css';
import './Buttons.css';
import PlantingWindowCal from './PlantingWindowCal';
import './PlantingWindowCal.css';
import ShoppingCart from './ShoppingCart';
import EmailVerification from './EmailVerification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsClapping, faHeart, faComment } from '@fortawesome/free-solid-svg-icons';
import WhyGrowContent from './Utilities/WhyGrowContent';
import HomebaseInstructions from './Utilities/HomebaseInstructions';
import api from '../api';
import imageCompression from 'browser-image-compression';
import axios from 'axios';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

const HomeBaseForm = ({ currentGardener, setCurrentGardener, userPlantData, fetchCurrentGardener, deferredPrompt, setDeferredPrompt, isDemoMode, currentDate, isLockedOutMode }) => {
  const [currentTask, setCurrentTask] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [taskFeedback, setTaskFeedback] = useState('');
  const [announcements, setAnnouncements] = useState([]);
  const [seasonalTasks, setSeasonalTasks] = useState([]);
  const [seasonalHeader, setSeasonalHeader] = useState([]);
  const [newCaption, setNewCaption] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [socialPosts, setSocialPosts] = useState([]);
  const [showWhyGrow, setShowWhyGrow] = useState(false);
  const [threadTitle, setThreadTitle] = useState('');
  const [showCommentForm, setShowCommentForm] = useState({});
  const [commentText, setCommentText] = useState({});
  const [validationHint, setValidationHint] = useState('');
  const [showInstructions, setShowInstructions] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showOnboardingMessage, setOnboardingMessage] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [showNotificationSetupMessage, setShowNotificationSetupMessage] = useState(false);
  const [showShoppingCart, setShowShoppingCart] = useState(false);
  const [showIOSInstructions, setShowIOSInstructions] = useState(false);
    const [canShowPreorderButton, setCanShowPreorderButton] = useState(false);
    const [isSubscribedForPreorder, setIsSubscribedForPreorder] = useState(false);
    const [preorderMessage, setPreorderMessage] = useState(null);
    const [hasExistingOrder, setHasExistingOrder] = useState(false);
    const [taskReport, setTaskReport] = useState([]);
    const [taskReportMessage, setTaskReportMessage] = useState("");
const [showTaskReport, setShowTaskReport] = useState(false);
const [showEmailVerification, setShowEmailVerification] = useState(false);
const [emailVerificationMessage, setEmailVerificationMessage] = useState("");
const [dontTrackMap, setDontTrackMap] = useState({});
    const [protectionAdvisories, setProtectionAdvisories] = useState([]);

    const [currentVarieties, setCurrentVarieties] = useState([]);
    const [recommendedVarieties, setRecommendedVarieties] = useState([]);
    const [selectedUserVariety, setSelectedUserVariety] = useState('');
    const [selectedRecommendedVariety, setSelectedRecommendedVariety] = useState('');
    const [newVariety, setNewVariety] = useState('');

  const isThreadTitleEmpty = threadTitle.trim().length === 0;
    const isCaptionEmpty = newCaption.trim().length === 0;

const isIOS =
  /iPhone|iPad|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);


    // Detect if PWA is already installed 
    const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true;

    const [notificationPermission, setNotificationPermission] = useState(
        isStandalone ? Notification.permission : 'default'
    );


    const isSafari =
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome") &&
        !navigator.userAgent.includes("CriOS") &&
        !navigator.userAgent.includes("FxiOS");

    const isIOSSafari = isIOS && isSafari;


  const isPostDisabled =
    isDemoMode ||
    isThreadTitleEmpty ||
    isCaptionEmpty;


  useEffect(() => {
    fetchCurrentGardener(isDemoMode);
  }, [isDemoMode]);

  const hasRunRef = useRef(false);

    useEffect(() => {
        if (hasRunRef.current) return; //prevent double-run

        if (currentGardener?.isNewUser && !showOnboardingMessage) {
            hasRunRef.current = true;

            setOnboardingMessage(true);

            //mark them as no longer new
            api.put(`/gardeners/${currentGardener.id}`, {
                ...currentGardener,
                isNewUser: 0
            }).then(() => {

                //trigger the welcome email
                api.post('/sendWelcomeEmail/runTask/', {
                    gardenerID: currentGardener.id
            });
          });
        }
    }, [currentGardener?.isNewUser]);

    // load the dont track flag for each plantID so we know 
    // which to display the dontTrack button or in planting mode
    useEffect(() => {
    if (!userPlantData) return;
        console.log("userPlantData:", JSON.parse(JSON.stringify(userPlantData)));
    const map = {};
    userPlantData.forEach(up => {
        map[up.plantID] = up.dontTrack === true;
    });
        console.log("dontTrackMap:", map);
    setDontTrackMap(map);
}, [userPlantData]);


    const fetchPreorderStatus = async () => {
        try {
            const res = await api.get(`/gardeners/preorder/status/${currentGardener.locationID}`);

            const { isSubscribed, hasExistingOrder, message, canShowPreorderButton } = res.data;

            setCanShowPreorderButton(canShowPreorderButton);
            setIsSubscribedForPreorder(isSubscribed);
            setHasExistingOrder(hasExistingOrder);

        // If any of the preorder conditions fail, stop here
        if (!isSubscribed || hasExistingOrder || !canShowPreorderButton) {
            return;
        }


    } catch (err) {
        console.error("Failed to load preorder status", err);
    }
};

  useEffect(() => {
    if (currentGardener?.id) {
      fetchCurrentTask();
      fetchSeasonalHeader();
      fetchSeasonalTasks();
      fetchAnnouncements();
      fetchSocialPosts();

      fetchPreorderStatus();
        fetchProtectionAdvisories();

    }
  }, [currentGardener?.id]);

  useEffect(() => {
  if (seasonalTasks.length > 1) {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % seasonalTasks.length);
    }, 5000); // change every 5 seconds
    return () => clearInterval(interval);
  }
}, [seasonalTasks]);

useEffect(() => {
    if (currentGardener?.show_setup_notification) {
        setShowNotificationSetupMessage(true);
    } else {
        setShowNotificationSetupMessage(false);
    }
}, [currentGardener]);

useEffect(() => {
    if (isStandalone) {
        setNotificationPermission(Notification.permission);
    }
}, [isStandalone]);

    const fetchProtectionAdvisories = async () => {
        try {
            const res = await api.get('/journal/protection', {
                params: {
                    gardenerID: currentGardener.id,
                    scheduleTable: currentGardener.scheduleTable
                }
            });

            let allAdvisories = res.data || [];

            // Sort by start date
            allAdvisories.sort((a, b) => new Date(a.date) - new Date(b.date));

            // Filter by date range using simulated currentDate
            const today = new Date(currentDate);
            const active = allAdvisories.filter(a => {
                const start = new Date(a.date);
                const end = new Date(a.eventEndDate);
                return today >= start && today <= end;
            });

            setProtectionAdvisories(active);
        } catch (err) {
            console.error("Error fetching protection advisories:", err);
        }
    };

    const fetchVarietiesForTask = async (plantId, gardenerID, plantingRegionID) => {
        try {
            console.log("ABOUT TO FETCH VARIETIES... PASSING IN ", plantId, gardenerID, plantingRegionID);
            const response = await api.get(
                `/gardenerPlants/varieties/${plantId}/${gardenerID}/${plantingRegionID}`
            );

            setCurrentVarieties(response.data.currentVarieties || []);
            setRecommendedVarieties(response.data.recommendedVarieties || []);

            console.log('CURRENT VARIETIES:', response.data.currentVarieties);
            console.log('RECOMMENDED VARIETIES:', response.data.recommendedVarieties);

        } catch (err) {
            console.error('Error fetching varieties:', err);
            setCurrentVarieties([]);
            setRecommendedVarieties([]);
        }
    };

const fetchCurrentTask = async () => {
  try {
    const gardenerID = currentGardener?.id;
    console.log('within fetchCurrentTask here is gardenerid:', gardenerID);
    if (!gardenerID) return;

    const response = await api.get('/journal/current', {
        params: {
            gardenerID: currentGardener.id,
            scheduleTable: currentGardener.scheduleTable
        }
    });

    const data = response.data;
      console.log('after fetch here is the data returned:', data);
      setNewVariety('');
      setCurrentTask(data || null);

      // Fetch varieties for the variety-count or variety-name question
      if (
          (
              data?.task?.toLowerCase() === 'what is the variety name?'
          ) 
      ) {
          await fetchVarietiesForTask(
              data.plantId,
              gardenerID,
              data.plantingRegionID
          );
      }

  } catch (err) {
    console.error('Error fetching current task:', err);
  }
};

const fetchSeasonalTasks = async () => {
  if (!currentGardener?.id) return;

  const gardenerID = currentGardener.id;

  try {
    const response = await api.get('/seasonalTips', {
      params: {
        gardenerID,
        currentDate
      }
    });

    const data = response.data;
    setSeasonalTasks(data);
  } catch (err) {
    console.error('Error fetching seasonal tasks:', err);
  }
};

const fetchSeasonalHeader = async () => {
  if (!currentGardener?.id) return;

  const gardenerID = currentGardener.id;

  try {
    const response = await api.get('/tasks/seasonal', {
      params: {
        gardenerID,
        currentDate,
        scheduleTable: currentGardener.scheduleTable
      }
    });

    const data = response.data;
    setSeasonalHeader(data);
  } catch (err) {
    console.error('Error fetching seasonal tasks:', err);
  }
};

const fetchAnnouncements = async () => {
  try {
    const response = await api.get('/announcements', { params: {currentDate}});
    const data = response.data;
    setAnnouncements(data);
  } catch (err) {
    console.error('Error fetching announcements:', err);
  }
};

    const loadMorePosts = async () => {
        const newOffset = socialPosts.length;

        try {
            const response = await api.get('/social/posts', {
                params: {
                    limit: 50,
                    offset: newOffset
                }
            });

            const morePosts = response.data;

            // Append older posts to the bottom
            setSocialPosts(prev => [...prev, ...morePosts]);

        } catch (err) {
            console.error("Error loading older posts:", err);
        }
    };


const fetchSocialPosts = async () => {
  try {
    const response = await api.get('/social/posts');
    const data = response.data;
    setSocialPosts(data);
  } catch (err) {
    console.error('Error fetching social posts:', err);
  }
};

const handleInstallClick = async () => {

    if (isIOSSafari) {
        setShowIOSInstructions(prev => !prev);
        return;
    }

    if (deferredPrompt) {
        deferredPrompt.prompt();
        const choiceResult = await deferredPrompt.userChoice;

        if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the install prompt');

            // Force refresh so UI updates immediately
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {
            console.log('User dismissed the install prompt');
        }

        setDeferredPrompt(null);
    }
};

const handleEnableNotifications = async () => {
   if (!isStandalone) {
       console.log('Not in standalone mode � skipping notification setup');
       return;
   }

   try {
       const permission = await Notification.requestPermission();
       setNotificationPermission(permission);

       if (permission === 'granted') {
                if (!VAPID_PUBLIC_KEY || !currentGardener?.id) {
                    console.warn('Missing VAPID key or gardener ID � cannot subscribe to push.');
                    return;
                }

                const registration = await navigator.serviceWorker.ready;

                let subscription = await registration.pushManager.getSubscription();

                if (!subscription) {
                    subscription = await registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
                    });
                }

                if (!subscription) console.warn('Subscription failed or not supported.');
     
                // tell backend to hide the setup notification 
                const token = localStorage.getItem('token');

                await axios.post(
                    `/api/gardeners/${currentGardener.id}/hide-setup-notification`,
                    {}, // no body needed
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            
                // update local state so UI hides banner + button 
                setCurrentGardener(prev => ({ 
                    ...prev, show_setup_notification: false 
                }));                
            
            } else {
                console.warn('User denied notification permission.');
            }
    } catch (err) {
       console.error('Error enabling notifications:', err);
    }
};

  const handleAnnouncementDetails = (item) => {
    alert(`Details for "${item.Title}"\n\n${item.Description}`);
  };

    const handleTaskSubmit = async () => {
        if (!currentTask) return;

        const type = currentTask?.expectedAnswer;
        const gardenerID = currentGardener?.id;

        const isLastMessage = currentTask.userPlantField === 'lastMessage';

        let trimmedAnswer;

        if (isLastMessage) {
            const [month, day, year] = currentDate.split('-');
            const monthNumber = new Date(`${month} 1, ${year}`).getMonth() + 1;

            trimmedAnswer = `${year}-${String(monthNumber).padStart(2, '0')}-${day}`;
        } else {
            trimmedAnswer = userAnswer.trim();
        }
        let backendAnswer = trimmedAnswer;

        if (type?.toLowerCase() === 'yesno') {
            backendAnswer = trimmedAnswer.split(' - ')[0];
        }

        if (!trimmedAnswer) {
            setTaskFeedback(getPlaceholder(type));
            return;
        }

        // ------------------------------------------------------------ 
        // SHOPPING CART INTERCEPT 
        // ------------------------------------------------------------ 
        if (currentTask.taskType === 'shoppingCart') { 
            if (trimmedAnswer === 'yes') { 
                // Navigate to ShoppingCart screen 
                setShowShoppingCart(true); 
                return; 
            } else { 
                // User said no  treat as normal completion 
                // (or skip, depending on your logic) 
            } 
         } 
         // ------------------------------------------------------------
         // NORMAL TASK SUBMISSION 
         // ------------------------------------------------------------

        try {
            const response = await api.post('/journal/answer', {
            taskId: currentTask.taskId,
            message: backendAnswer,
                currentDate,
                scheduleTable: currentGardener.scheduleTable,
            });

            const result = response.data;

            if (result.success) {
                //setTaskFeedback('Answer submitted.');
                setTaskFeedback(null);
                setUserAnswer('');

                if (currentTask.userPlantField === 'variety') {
                    await fetchCurrentGardener();   // refresh sidebar ONLY when variety changes
                }

            fetchCurrentTask();
            } else {
            setTaskFeedback(result.message || getPlaceholder(type)); // Show hint if backend says it's invalid
            }
        } catch (err) {
            console.error('Error submitting task:', err);
            setTaskFeedback('Something went wrong. Please try again.');
        }
    };

    const handleNotYetPlant = async () => {
        if (!currentTask) return;

        const type = currentTask?.expectedAnswer;
        const gardenerID = currentGardener?.id;

        // snooze till today plus 7 days
        const base = new Date(currentDate);
        base.setDate(base.getDate() + 7);
        const snoozeDate = base.toISOString().slice(0, 10);

        // ------------------------------------------------------------
        // PLANTING NOT YET
        // ------------------------------------------------------------

        try {
            const response = await api.post('/journal/answer', {
                taskId: currentTask.taskId,
                message: userAnswer,
                currentDate,
                scheduleTable: currentGardener.scheduleTable,
                plantingSnoozeTill: snoozeDate
            });

            const result = response.data;

            if (result.success) {
                setTaskFeedback('Answer submitted.');
                setUserAnswer('');

                fetchCurrentTask();
            } else {
                setTaskFeedback(result.message || getPlaceholder(type));
            }
        } catch (err) {
            console.error('Error submitting planting Not Yet:', err);
            setTaskFeedback('Something went wrong. Please try again.');
        }
    };

    const handleNotYet = async () => {
        if (!currentTask) return;

        const type = currentTask?.expectedAnswer;
        const gardenerID = currentGardener?.id;

        // snooze till today plus 7 days
        const base = new Date(currentDate);
        base.setDate(base.getDate() + 7);
        const snoozeDate = base.toISOString().slice(0, 10);

        // ------------------------------------------------------------
        // NORMAL TASK SUBMISSION 
        // ------------------------------------------------------------

        try {
            const response = await api.post('/journal/answer', {
                taskId: currentTask.taskId,
                message: userAnswer,
                currentDate,
                scheduleTable: currentGardener.scheduleTable,
                snoozeTill: snoozeDate
            });

            const result = response.data;

            if (result.success) {
                setTaskFeedback('Answer submitted.');
                setUserAnswer('');

                fetchCurrentTask();
            } else {
                setTaskFeedback(result.message || getPlaceholder(type)); // Show hint if backend says it's invalid
            }
        } catch (err) {
            console.error('Error submitting task:', err);
            setTaskFeedback('Something went wrong. Please try again.');
        }
    };

    const handleNotYetHarvest = async () => {
        if (!currentTask) return;

        const type = currentTask?.expectedAnswer;
        const gardenerID = currentGardener?.id;

        // snooze till today plus 7 days
        const base = new Date(currentDate);
        base.setDate(base.getDate() + 7);
        const snoozeDate = base.toISOString().slice(0, 10);

        // ------------------------------------------------------------
        // NORMAL TASK SUBMISSION 
        // ------------------------------------------------------------

        try {
            const response = await api.post('/journal/answer', {
                taskId: currentTask.taskId,
                message: userAnswer,
                currentDate,
                scheduleTable: currentGardener.scheduleTable,
                harvestSnoozeTill: snoozeDate
            });

            const result = response.data;

            if (result.success) {
                setTaskFeedback('Answer submitted.');
                setUserAnswer('');

                fetchCurrentTask();
            } else {
                setTaskFeedback(result.message || getPlaceholder(type)); // Show hint if backend says it's invalid
            }
        } catch (err) {
            console.error('Error submitting task:', err);
            setTaskFeedback('Something went wrong. Please try again.');
        }
    };



const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
        const options = {
            maxSizeMB: 0.15, // ~150 KB max 
            maxWidthOrHeight: 800, // perfect for social feed 
            initialQuality: 0.6, 
            useWebWorker: true
        };

        const compressedFile = await imageCompression(file, options);

        // Store the compressed file instead of the original
        setImageFile(compressedFile);

    } catch (error) {
        console.error("Image compression failed:", error);
        setImageFile(file); // fallback to original if compression fails
    }
};

    const getImageUrl = (filename) =>
        `${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/social/${filename}`;


const handlePostSubmit = async (e) => {
  e.preventDefault();

  const titleEmpty = threadTitle.trim().length === 0; 
  const captionEmpty = newCaption.trim().length === 0; 
  
  if (titleEmpty || captionEmpty) { 
      setShowValidationErrors(true); 
      return; 
  } 
  
  setShowValidationErrors(false);
  
  const formData = new FormData();
  formData.append('caption', newCaption);
  formData.append('threadTitle', threadTitle);
  formData.append('image', imageFile);
  formData.append('gardenerID', currentGardener.id);

  try {
    const response = await api.post('/social/posts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    const newPost = response.data;
    console.log('New post received from server:', newPost);
    console.log('Image filename from server:', newPost.imageFilename);

    setSocialPosts(prev => [newPost, ...prev]);
    setNewCaption('');
    setThreadTitle('');
    setImageFile(null);
  } catch (err) {
    console.error('Error submitting post:', err);
  }
};

    const threads = socialPosts.reduce((acc, post) => {
        const title = post.threadTitle || 'Untitled';
        if (!acc[title]) acc[title] = [];
        acc[title].push(post);
        return acc;
    }, {});

    const toggleCommentForm = (postId) => {
        setShowCommentForm(prev => ({ ...prev, [postId]: !prev[postId] }));
    };

const handleReaction = async (postId, type) => {
  try {
    const response = await api.post(`/social/posts/${postId}/react`, { type });
    const { loveCount, applauseCount } = response.data;

    setSocialPosts(prev =>
      prev.map(post =>
        post.id === postId
          ? { ...post, loveCount, applauseCount }
          : post
      )
    );
    } catch (error) {
            console.error('Reaction failed:', error);
    }
  };

    const handleCommentSubmit = async (e, postId) => {
        e.preventDefault();
        const text = commentText[postId];
        if (!text) return;
        console.log('Submitting comment with:', {
            postId,
            text: commentText[postId],
            gardenerId: currentGardener?.gardenerID,
            currentGardener
        });

  try {
    const response = await api.post(`/social/posts/${postId}/comments`, {
      text,
      gardenerID: currentGardener.id
    });

    const { comments } = response.data;
            setSocialPosts(prev =>
                prev.map(p => (p.id === postId ? { ...p, comments } : p))
            );
            setCommentText(prev => ({ ...prev, [postId]: '' }));
        } catch (err) {
            console.error('Error submitting comment:', err);
        }
    };

const handleViewTasks = async (range) => {
    try {
        const res = await api.get(`/tasks/${range}/${currentGardener.id}`, {
            params: {
                scheduleTable: currentGardener.scheduleTable,
                currentDate: currentDate
            }
        });

        if (!res.data || res.data.length === 0) {
            setTaskReportMessage(
                "All caught up! No tasks today - your garden is on track."
            );
        } else {
            setTaskReportMessage("");
        }

        setTaskReport(res.data || []);
        setShowTaskReport(true);

    } catch (err) {
        console.error("Error fetching tasks:", err);
    }
};

const handleDontTrackCrop = async () => {
  try {
    await api.put("/journal/removeTasksDontTrack", {
      gardenerId: currentGardener.id,
      plantID: currentTask.plantId,
      scheduleTable: currentGardener.scheduleTable
    });
    // update local map
    setDontTrackMap(prev => ({
        ...prev,
        [currentTask.plantId]: true
    }));
    
    setTaskFeedback("This crop is now in planting-only mode going forward.");
  } catch (error) {
    console.error("Error updating crop mode:", error);
    setTaskFeedback("Something went wrong updating crop mode.");
  }
};

const handleSkipQuestion = async () => {
    const field = currentTask.userPlantField;

  try {
      //flip flag...in journalVisible and then just delete those questions from schedule task
    await api.put("/journal/skipVisibility", {
        gardenerID: currentGardener.id,
      scheduleTable: currentGardener.scheduleTable,
      field
    });

   //we need to call the process answer to handle the next task
   const response = await api.post('/journal/answer', {
       taskId: currentTask.taskId,
       message: userAnswer,
       currentDate,
       scheduleTable: currentGardener.scheduleTable,
       skip: true
   });
   
   fetchCurrentTask();

  } catch (error) {
    console.error("Error skipping question:", error);
    setTaskFeedback("Something went wrong skipping question.");
  }
};


  const renderTaskCard = () => {
    if (!currentTask ||
  !currentTask.task ||
  !currentTask.expectedAnswer ||
  currentTask.taskType === 'summary') return <p>All tasks completed for now. Your journal is up to date!</p>;

      const startDate = currentTask.eventStartDate || currentTask.date;
      const endDate = currentTask.eventEndDate;

      // watch for the last harvesting questions to determine if we are moving into a cure task
      // or displaying the congratulations now check out preserve/meal
      let instruction = currentTask.instruction;
      let taskQuestion = currentTask.task

      const isLastMessage = currentTask.userPlantField === 'lastMessage';

      if (currentTask.eventType === 'Harvesting') {
          if (currentTask.userPlantField === 'harvestCure') {
              const parts = currentTask.task.split('|||');

              instruction = parts[0].trim();
              taskQuestion = parts[1]?.trim();
          }

          if (currentTask.userPlantField === 'lastMessage') {
              instruction = `Congratulations! You've completed the harvest journey for your ${currentTask.task}!<br/><br/>
        Now it's time to enjoy what you've grown.<br/><br/>
        Find or record your favourite meals in the Meal tab, and explore ways to preserve your harvest so you can enjoy it until your next harvest.`;
          }
      }
      // Adjust planting window start date for display only
      let displayStartDate = startDate;

      if (currentTask.eventType === 'Planting') {

          const NewcurrentDateObj = new Date(currentDate.replace(/-/g, ' '));
          const firstOfMonth = new Date(
              NewcurrentDateObj.getFullYear(),
              NewcurrentDateObj.getMonth(),
              1
          );
          const cleanStart = startDate.split('T')[0];   
          const [sy, sm, sd] = cleanStart.split('-').map(Number);
          const startDateObj = new Date(sy, sm - 1, sd);   // LOCAL DATE, not UTC

          // If the window started before this month, shift display to first of month
          console.log("startdateObj and firstofmonth: ", startDateObj, firstOfMonth);
          if (startDateObj < firstOfMonth) {
              displayStartDate = firstOfMonth;
          }
      }

  const getWindowLabel = (eventType) => {
    switch (eventType) {
      case 'Germinating':
        return 'Germination Window';
      case 'Thinning':
        return 'Thinning Window';
      case 'Harvesting':
        return 'Harvest Window';
      default:
        return 'Planting Window';
    }
  };

  const skippableFields = [
  "seedDepth",
  "seedSpace",
  "rowSpace",
  "soilTemperature",
  "dailyMinTemp",
  "dailyMaxTemp",
  "plantingNotes",
  "germinationNotes",
  "thinningOut",
  "thinningNotes",
  "transplantAmount",
  "transplantNote",
  "harvestAmount",
  "harvestNotes",
      "amount",
  "harvestDate"
];


const shouldShowSkip = (userPlantField) => {
    return skippableFields.includes(userPlantField);
};

const shouldShowDontTrack = (userPlantField) => {
  return userPlantField === 'planted';
};

const currentDateObj = new Date(currentDate);
const taskDateObj = new Date(currentTask.date);

const FORTY_FIVE_DAYS = 45 * 24 * 60 * 60 * 1000;

    return (
    <> 

      <div className="task-card">
        <div className="instruction-calendar-row">
          <div className="task-instruction-column">
                        {instruction?.includes('<br') ? (
                            <div className="task-instruction-formatted">
                                {instruction.split(/<br\s*\/?>/i)
                                    .map(part => part.trim())
                                    .filter(Boolean)
                                    .map((part, index) => (
                                        <div
                                            key={index}
                                            className={
                                                index === 0
                                                    ? "harvest-instruction-heading"
                                                    : "harvest-instruction-detail"
                                            }
                                        >
                                            {index === 0 ? <h4>{part}</h4> : part}
                                        </div>
                                    ))}
                            </div>
                        ) : (
                            <h4>{instruction}</h4>
                        )}
                        <div className="question-input-group">
                  {!isLastMessage && (
                      <>
                         <label htmlFor="task-answer" className="task-question">
                                        {taskQuestion}
                         </label>
                            <div className="task-dropdown">

                                {currentTask?.userPlantField === 'variety' ? (

                                    <>
                                        {currentVarieties.length > 0 && (
                                            <select
                                                value={selectedUserVariety}
                                                onChange={(e) => {
                                                    setNewVariety('');
                                                    setSelectedUserVariety(e.target.value);
                                                    setSelectedRecommendedVariety('');
                                                    setUserAnswer(e.target.value)
                                                }}
                                            >
                                                <option value="">Select from my varieties</option>

                                                {currentVarieties.map((variety) => (
                                                    <option
                                                        key={variety.id}
                                                        value={`uservariety|${variety.id}`}
                                                    >
                                                        {variety.name}
                                                    </option>
                                                ))}

                                            </select>
                                        )}

                                        {recommendedVarieties.length > 0 && (

                                            <select
                                                value={selectedRecommendedVariety}
                                                onChange={(e) => {
                                                    setNewVariety('');
                                                    setSelectedRecommendedVariety(e.target.value);
                                                    setSelectedUserVariety('');
                                                    setUserAnswer(e.target.value)
                                                }}
                                            >
                                                <option value="">Select from recommended varieties</option>

                                                {recommendedVarieties.map((variety) => (
                                                    <option
                                                        key={variety.id}
                                                        value={`recommended|${variety.id}|${variety.name}`}
                                                    >
                                                        {variety.name}
                                                    </option>
                                                ))}


                                            </select>
                                        )}

                                        <input
                                            type="text"
                                            className="variety-input"
                                            value={newVariety }
                                            onChange={(e) => {
                                                setNewVariety(e.target.value);
                                                setSelectedRecommendedVariety('');
                                                setSelectedUserVariety('');
                                                setUserAnswer(`new|${e.target.value}`)
                                            }}
                                            placeholder="Enter a new variety"
                                        />
                                    </>

                                ) : (

                                    renderInputField({
                                        expectedAnswer: currentTask?.expectedAnswer,
                                        value: userAnswer,
                                        onChange: (e) => setUserAnswer(e.target.value),
                                        currentVarieties,
                                        recommendedVarieties,
                                        eventType: currentTask?.eventType,
                                        plantingMethod: currentTask?.plantingMethod
                                    })

                                )}

                            </div>
                      </>
                  )}

              <button 
                className="button" 
                onClick={handleTaskSubmit} 
                disabled={isDemoMode || isLockedOutMode}
                >
                Enter
              </button>

                            {currentTask.eventType === 'Planting' && currentTask.userPlantField === 'planted' && (
                                <button
                                    className="button"
                                    onClick={handleNotYetPlant}
                                    disabled={isDemoMode || isLockedOutMode}
                                >
                                    Not Yet
                                </button>
                            )}

                            {currentTask.eventType === 'Germinating' && currentTask.userPlantField === 'germinationDate' && (
                                <button
                                    className="button"
                                    onClick={handleNotYet}
                                    disabled={isDemoMode || isLockedOutMode}
                                >
                                    Not Yet
                                </button>
                            )}

           {currentTask.eventType === 'Harvesting' && taskQuestion.startsWith('Have you harvested your') && (
                <button
                    className="button"
                    onClick={handleNotYetHarvest}
                    disabled={isDemoMode || isLockedOutMode}
                >
                    Not Yet
                </button>
            )}

           {shouldShowSkip(currentTask.userPlantField) && (
                            <button
                                className="button"
                                onClick={handleSkipQuestion}
                                disabled={isDemoMode || isLockedOutMode}
                            >
                                Skip
                            </button>
            )}   

                {currentTask?.userPlantField === 'planted' && 
                 currentTask?.eventType === 'Planting' && (
                    dontTrackMap[currentTask.plantId] ? (
                        <div className="planting-only-mode">
                            Planting-only mode
                        </div>
                    ) : (
                        <button
                            className="button"
                            onClick={handleDontTrackCrop}
                            disabled={isDemoMode || isLockedOutMode}
                        >
                            Don't Track
                        </button>
                    )
                )}


              {isDemoMode && <p className="demo-hint">Task submission is disabled in demo mode.</p>}
              {isLockedOutMode && <p className="demo-hint">Task submission is disabled, your trial period has ended.</p>}
              {taskFeedback && <p className="task-feedback" aria-live="polite">{taskFeedback}</p>}

              {currentTask.reminder && (
                <p className="task-reminder">
                    {currentTask.reminder}
                </p>
            )}

            </div>
          </div>
          {startDate && endDate && (
            <div
                className="task-calendar-column"
                aria-hidden="true"
                tabIndex="-1"
            >
             <h5 className="calendar-label">
              {getWindowLabel(currentTask.eventType)}
            </h5>
                            <PlantingWindowCal startDate={displayStartDate} endDate={endDate} currentDate={currentDate } />
            </div>
          )}
        </div>
      </div>
      </>
    );
    };

const renderSocialCard = (post) => {
    const imageUrl = getImageUrl(post.imageFilename);
    const commentValue = commentText[post.id] || "";
    const isCommentEmpty = commentValue.trim().length === 0;

    return (
        <div key={post.id} className="social-card">

            {/* Header */}
            <div className="card-header">
                <div className="card-header-left">
                    <strong>{post.username}</strong>
                </div>

                <div className="card-header-center">
                    {post.threadTitle && (
                        <span className="card-thread-title">
                            {post.threadTitle}
                        </span>
                    )}
                </div>

                <div className="card-header-right">
                    <span className="card-timestamp">
                        {formatDate(post.created_at)}
                    </span>
                </div>
            </div>

            {/* Image */}
            {post.imageFilename && (
                <div className="card-image">
                    <img
                        src={imageUrl}
                        alt={`Post from ${post.username}`}
                    />
                </div>
            )}

            {/* Body */}
            <div className="card-body">

                {/* Caption / Question */}
                {post.caption && (
                    <p className="card-caption">{post.caption}</p>
                )}

                {/* Reactions */}
                <div className="card-reactions">
                    <button
                        aria-label="React with clapping"
                        onClick={() => handleReaction(post.id, "applause")}
                        className="reaction-button"
                        disabled={isDemoMode || isLockedOutMode}
                    >
                        <FontAwesomeIcon icon={faHandsClapping} />
                        <span className="reaction-count">
                            {post.applauseCount ?? 0}
                        </span>
                    </button>

                    <button
                        aria-label="React with heart"
                        onClick={() => handleReaction(post.id, "love")}
                        className="reaction-button"
                        disabled={isDemoMode || isLockedOutMode}
                    >
                        <FontAwesomeIcon icon={faHeart} />
                        <span className="reaction-count">
                            {post.loveCount ?? 0}
                        </span>
                    </button>

                    <button
                        onClick={() => toggleCommentForm(post.id)}
                        aria-label="React with comment"
                        className="reaction-button"
                        disabled={isDemoMode || isLockedOutMode}
                    >
                        <FontAwesomeIcon icon={faComment} />
                    </button>
                </div>

                {/* Comment Form */}
                {showCommentForm[post.id] && (
                    <form
                        onSubmit={(e) => handleCommentSubmit(e, post.id)}
                        className="comment-form"
                    >
                        <input
                            type="text"
                            placeholder="Add a comment..."
                            value={commentValue}
                            onChange={(e) =>
                                setCommentText((prev) => ({
                                    ...prev,
                                    [post.id]: e.target.value,
                                }))
                            }
                        />

                        <button
                            type="submit"
                            className="button"
                            disabled={isDemoMode || isCommentEmpty || isLockedOutMode}
                        >
                            Post
                        </button>

                        {isDemoMode && (
                            <p className="demo-hint">
                                Posting is disabled in demo mode.
                            </p>
                        )}
                        {isLockedOutMode && (
                            <p className="demo-hint">
                                Posting is disabled, your trial period has ended.
                            </p>
                        )}
                    </form>
                )}

                {/* Comments */}
                {post.comments?.length > 0 && (
                    <div className="card-comments">
                        {post.comments.map((comment, index) => (
                            <div key={index} className="comment">
                                <strong>{comment.commenter}</strong>:{" "}
                                {comment.text}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

    return (
     <>
       {showShoppingCart && ( 
         <div className="cart-overlay">
             <ShoppingCart 
                currentGardener={currentGardener} 
                userPlantData={userPlantData} 
                currentDate={currentDate} 
                onClose={() => { 
                    setShowShoppingCart(false); 
                    fetchCurrentTask(); // resume task engine 
                    fetchPreorderStatus();
                 }}
                /> 
          </div>
        )}

        {showEmailVerification && (
    <div className="cart-overlay">
        <EmailVerification
            gardener={currentGardener}
            message={emailVerificationMessage}
            onClose={() => setShowEmailVerification(false)}
            onVerified={async () => {
                await fetchCurrentGardener();
                await fetchPreorderStatus();
            }}
        />
    </div>
)}


{showTaskReport && (
    <div className="task-report-overlay">
        <div className="task-report-box">
            <h2>Your Tasks</h2>

            <button className="button" onClick={() => window.print()}>
                Print
            </button>

            <button className="button" onClick={() => setShowTaskReport(false)}>
                Close
            </button>

<div className="task-report-list">
    {taskReportMessage ? (
        <div className="task-complete-message">
            <h3>{taskReportMessage}</h3>
        </div>
    ) : (
        taskReport.map((t, i) => (        <div key={i} className="task-report-item">

            {/* Icon */}
            {t.icon && (
                <img
                    src={`data:image/png;base64,${t.icon}`}
                    alt="Crop icon"
                    className="task-icon"
                />
            )}

            {/* Window Label */}
            <span className="task-window">
                <strong>
                    {t.eventType} Window:
                </strong>{" "}
                {t.date} to {t.eventEndDate}
            </span>

            {/* Instruction */}
            <p className="task-instruction">{t.task}</p>

      {/* Companions � ONLY for Planting + Transplanting */}
      {(t.eventType === "Planting" || t.eventType === "Transplanting") &&
        t.companionInfo && (
          <p><strong>Companions:</strong> {t.companionInfo}</p>
      )}

        </div>
    )))}
</div>
        </div>
    </div>
)}


      <div className="homebase-container" >
      <section className="compact-banner-grid">
        {showOnboardingMessage && (
            <div className="homebase-intro-highlight">
                <h3>
                <strong>Welcome to GrowYourFoodApp</strong><br />
                </h3>

               {/* Handbook notice */}
               <p><strong>We just emailed you your Gardener Handbook - start with the "Start Here" section.</strong></p>

                {/* Case 1: App Not installed */}
                {!isStandalone && (
                    <>
                        <h3>Don't miss your planting tasks</h3>
                        <p>Install GrowYourFoodApp for instant reminders when it's time to plant, thin, protect, and harvest.</p>
                        <button className="button" onClick={handleInstallClick}>
                            Install App
                        </button>
                    </>
                )}

                {/* Case 2: Installed but notifications NOT granted */}
                {isStandalone && Notification.permission !== "granted" && ( 
                    <> 
                        <h3>Enable reminders to stay on track</h3>
                        <p>Turn on notifications so we can nudge you at the right moments throughout the season.</p>
                        <button className="button" onClick={handleEnableNotifications}>
                            Enable Notifications
                        </button>
                    </> 
                )} 

                {/* Case 3: Installed AND notifications granted */} 
                {isStandalone && Notification.permission === "granted" && ( 
                    <> 
                        <p><strong>You're all set!</strong>
                        </p> 
                        <p> Your app is installed and reminders are enabled. We'll guide you at the right moments throughout the season. 
                        </p> 
                    </> 
                )}
            <button
                className="button"
                onClick={async () => { 
                    setOnboardingMessage(false)
                    await fetchCurrentGardener(); // refresh state in App.js
                }}
                >
               {isIOS ? "Finish Onboarding" : "Got it - Let me take the reins!"}
            </button>
        </div>
        )}

{showNotificationSetupMessage && (
    <div className="notification-setup-banner">
        <h3>
            <strong>You have planting tasks waiting - <br />
            but GrowYourFoodApp can't reach you!</strong>
        </h3>

        {/* Case 1: App NOT installed */}
        {!isStandalone && (
            <>
                <p>
                    Install the App Now.
                </p>
                <button className="button" onClick={handleInstallClick}>
                        Install App
                </button>
            </>
        )}

        {/* Case 2: App installed but notifications NOT enabled */}
        {isStandalone && Notification.permission !== "granted" && (
            <>
                <p>
                    Enable notifications now.
                </p>
                <button className="button" onClick={handleEnableNotifications}>
                    Enable Notifications
                </button>
            </>
        )}

    </div>
)}


        <div className="banner-greeting">
                    <h2>Welcome back, {currentGardener?.name || 'Gardener'}!</h2>
                    <div className="homebase-toggle-buttons">
                    <button
                        type="button"
                        className="button"
                        onClick={() => setShowWhyGrow(prev => !prev)}
                        aria-expanded={showWhyGrow}
                        aria-controls="why-grow-content"
                    >
                        {showWhyGrow ? 'Hide Why Grow Your Own Food' : 'Why Grow Your Own Food?'}
                    </button>


                    {showWhyGrow && (
                        <div className="instructions-panel">
                            <WhyGrowContent />
                        </div>
                    )}

                    <button
                        type="button"
                        className="button"
                        onClick={() => setShowInstructions(prev => !prev)}
                        aria-expanded={showInstructions}
                        aria-controls="homebase-instructions"
                    >
                        {showInstructions ? 'Hide Help' : 'Show Help'}
                    </button>


                    {showInstructions && (
                        <div className="instructions-panel">
                            <HomebaseInstructions />
                        </div>
                    )}

    {showIOSInstructions && isIOSSafari && !isStandalone && ( 
    <div className="ios-install-instructions">
        <div className="ios-install-box">
            <h3>To install GrowYourFoodApp on your iPhone/iPad (Safari):</h3>
            <ul>
                <li>Tap the <strong>Share</strong> icon (square with the arrow in the top right hand corner of your browser).</li>
                <li>Choose <strong>Add to Home Screen</strong>.</li>
                <li>Tap <strong>Add</strong> in the top-right corner.</li>
            </ul>

            <p style={{ marginTop: "12px", fontStyle: "italic" }}>
                If anything is unclear, open the FAQ page to watch the iPhone/iPad installation video.
            </p>

            <button className="button close-btn" onClick={() => setShowIOSInstructions(false)}>
                Close
            </button>
        </div>
    </div>
)}


                    </div>
        </div>

        <div className="banner-columns">
          <div className="banner-column-seasonal">
            <h3 className="banner-section-title">
                {seasonalHeader.length > 0
                ? seasonalHeader[0].message   // now used as the header
                : 'Seasonal Tips'}
            </h3>
            <p>
                {seasonalTasks.length > 0
                ? seasonalTasks[currentIndex].message
                : "No seasonal tips today - your garden's in great shape!"}
            </p>
          </div>

          <div className="banner-column-announcement">
            <h3 className="banner-section-title">Announcement</h3>
            <p>
              {announcements.length > 0
                ? announcements[0].Title
                : 'No announcements at the moment. Stay tuned for upcoming events!'}
              {announcements.length > 0 && (
                <button
                  className="details-button"
                  onClick={() => handleAnnouncementDetails(announcements[0])}
                >
                  More Details
                </button>
              )}
            </p>
          </div>
        </div>
            </section>

      <section className="section-container tasks-section" role="region" aria-labelledby="task-section-title">
        <h2 id="task-section-title" className="visually-hidden">Your Gardening Tasks</h2>
                    {protectionAdvisories.length > 0 && (
                        <div className="catch-up-banner">
                            <strong>Protection Advisories</strong>

                            {protectionAdvisories.map(a => (
                                <div key={a.taskId} className="protection-item">
                                    <p>{a.task}</p>
                                    <p className="date-range">
                                        {formatDate(a.date)} to {formatDate(a.eventEndDate)}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                    {canShowPreorderButton && (
                        <button
                            className="button"
                            onClick={() => {

                                if (!isSubscribedForPreorder) {
                                    setPreorderMessage(preorderMessage || "Preorder Starters is part of the GrowYourFoodApp subscription.  Please subscribe to use this feature.");

                                    setTimeout(() => {
                                        setPreorderMessage("");
                                    }, 5000);

                                    return;
                                }

                                if (hasExistingOrder) {
                                    setPreorderMessage("Order has already been placed for this month.");

                                    setTimeout(() => {
                                        setPreorderMessage("");
                                    }, 5000);

                                    return;
                                }

                                // ----------------------------------------------------
                                // EMAIL VERIFICATION GATE (correct location)
                                // ----------------------------------------------------
                                if (currentGardener.emailVerified === false || currentGardener.emailVerified === 0) {
                                    setEmailVerificationMessage("You must enter a valid email before you can preorder starters. We need to be able to reach you to confirm your pickup.");
                                    setShowEmailVerification(true);
                                    return;
                                }

                                setPreorderMessage(""); // optional clear
                                setShowShoppingCart(true);
                            }}

                        >
                            Preorder Starters
                        </button>)}

                    {preorderMessage && (
                        <div className="preorder-message">
                            {preorderMessage}
                        </div>
                    )}

<div className="task-view-buttons">
    <button
        className="button"
                            onClick={() => handleViewTasks("today")}
                            disabled={isDemoMode || isLockedOutMode}

    >
        View Today's Tasks
    </button>

</div>


                    {renderTaskCard()}
      </section>

<section className="post-composer" role="region" aria-labelledby="post-composer-title">
    <h3 id="post-composer-title">Share Your Garden</h3>

    <form onSubmit={handlePostSubmit} encType="multipart/form-data">

        {/* Thread Topic */}
        <div className="form-row">
        <label htmlFor="thread-title-input">Thread Topic </label>
        <input
            id="thread-title-input"
            type="text"
            placeholder="Start a new topic or continue an existing one"
            title="Start a new topic or continue an existing one"
            value={threadTitle}
            onChange={(e) => setThreadTitle(e.target.value)}
        />
        </div>

        {/* Your Post */}
        <div className="form-row">
        <label htmlFor="caption-input">Your Post </label>
        <input
            id="caption-input"
            type="text"
            placeholder="Ask your question or share what�s happening in your garden"
            title="Ask your question or share what�s happening in your garden"
            value={newCaption}
            onChange={(e) => setNewCaption(e.target.value)}
        />
        </div>

        {/* Add a Photo */}
        <div className="form-row">
        <label htmlFor="image-upload">Add a Photo (optional) </label>
        <input
            id="image-upload"
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
        />

        {imageFile && (
            <div className="image-preview">
                <p>Preview:</p>
                <img src={URL.createObjectURL(imageFile)} alt="Preview" width="200" />
            </div>
        )}
        </div>

        {/* Post Button */}
        <div className="form-row">
                            <button
                                type="submit"
                                className="button"
                                disabled={isDemoMode || isLockedOutMode}
                            >
            Post
        </button>

        {/* Validation Errors */}
        {showValidationErrors && (
            <div className="post-errors" role="alert">
                {threadTitle.trim().length === 0 && (
                    <p className="error-message">Please enter a thread topic.</p>
                )}
                {newCaption.trim().length === 0 && (
                    <p className="error-message">Please enter your post.</p>
                )}
            </div>
        )}

        {isDemoMode && (
            <p className="demo-hint">Posting is disabled in demo mode.</p>
        )}
        {isLockedOutMode && (
            <p className="demo-hint">Posting is disabled, your trial period has ended.</p>
        )}
        </div>
    </form>
</section>

      <section className="section-container social-section" role="region" aria-labelledby="community-garden-title">
        <h3 id="community-garden-title">Community Garden</h3>
        {socialPosts.length > 0 ? (
          <div className="social-cards">
                        {Object.entries(threads).map(([title, posts]) => (
                            <div key={title} className="thread-card">
                                <h3 className="thread-title">{title}</h3>
                                <div className="social-cards">
                                    {posts.map(post => renderSocialCard(post))}
                                </div>
                            </div>
                        ))}
           </div> 
        ) : (
          <p>No posts yet - be the first to share your garden!</p>
        )}
                {/* Add a load older post button */}
                    <button
                        className="button"
                        onClick={loadMorePosts}
                        disabled={isDemoMode || isLockedOutMode}
                    >
                        Load Older Posts
                    </button>
      </section>
    </div>
    </>
  );
};

export default HomeBaseForm;
